import ThemeGateway from "./gateway";

const themeGateway = new ThemeGateway();

export default themeGateway;
